// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as List from "@rescript/std/lib/es6/list.js";
import * as Util from "../../../common/util.bs.js";
import * as CardZoomAnimation from "../../CardZoomAnimation.bs.js";
import $$Image from "next/future/image";
import * as JsxRuntime from "react/jsx-runtime";

var prodDomains = {
  hd: [
    "au",
    "https://www.prezzee.com.au"
  ],
  tl: {
    hd: [
      "us",
      "https://www.prezzee.com"
    ],
    tl: {
      hd: [
        "uk",
        "https://www.prezzee.uk"
      ],
      tl: {
        hd: [
          "nz",
          "https://www.prezzee.co.nz"
        ],
        tl: /* [] */0
      }
    }
  }
};

var stgDomains = {
  hd: [
    "au",
    "https://stg.prezzee.com.au"
  ],
  tl: {
    hd: [
      "us",
      "https://stg.prezzee.com"
    ],
    tl: {
      hd: [
        "uk",
        "https://stg.prezzee.uk"
      ],
      tl: {
        hd: [
          "nz",
          "https://stg.prezzee.co.nz"
        ],
        tl: /* [] */0
      }
    }
  }
};

var isStg = process.env.NEXT_PUBLIC_PREZZEE_SERVER_URL.includes("stg");

function CountryFlagButton(props) {
  var category = props.category;
  var getLink = function (param) {
    var match = category.slug;
    switch (match) {
      case "au-cards" :
          if (isStg) {
            return List.assoc("au", stgDomains);
          } else {
            return List.assoc("au", prodDomains);
          }
      case "nz-cards" :
          if (isStg) {
            return List.assoc("nz", stgDomains);
          } else {
            return List.assoc("nz", prodDomains);
          }
      case "uk-cards" :
          if (isStg) {
            return List.assoc("uk", stgDomains);
          } else {
            return List.assoc("uk", prodDomains);
          }
      case "us-cards" :
          if (isStg) {
            return List.assoc("us", stgDomains);
          } else {
            return List.assoc("us", prodDomains);
          }
      default:
        return "";
    }
  };
  return JsxRuntime.jsx(CardZoomAnimation.make, {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("a", {
                          children: JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx($$Image, {
                                              src: category.img,
                                              alt: category.name,
                                              width: 200,
                                              height: 200,
                                              className: ""
                                            }),
                                        className: Cn.make(["rounded-full h-10 w-10 border-white-smoke border-0 mb-3 flex items-center justify-center mx-auto shadow-light"])
                                      }),
                                  JsxRuntime.jsx("p", {
                                        children: Util.ReactStuff.s(category.name),
                                        className: Cn.make(["text-center text-dark-gray text-sm"])
                                      })
                                ]
                              }),
                          className: "cursor-pointer",
                          href: getLink(category.slug),
                          target: "_blank"
                        })
                  }, category.name)
            });
}

var Img;

var make = CountryFlagButton;

export {
  Img ,
  prodDomains ,
  stgDomains ,
  isStg ,
  make ,
}
/* isStg Not a pure module */
